"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconMail = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("../Icon/SvgWrapper");
const IconMail = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M12 15c-.332 0-.625-.117-1.25-.42L2 10v8.75c0 .688.563 1.25 1.25 1.25h17.5c.688 0 1.25-.563 1.25-1.25V10l-8.75 4.58c-.625.303-.918.42-1.25.42zm8.75-10H3.25C2.562 5 2 5.563 2 6.25v.947l10 5.257 10-5.257V6.25C22 5.562 21.437 5 20.75 5z"
}));
exports.IconMail = IconMail;
//# sourceMappingURL=IconMail.js.map